module.exports = __webpack_public_path__ + "static/img/李志平名片PC.6472947.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/contact/李志平名片PC.jpg
// module id = GNeY
// module chunks = 1